import React from "react";
import { Icon } from "../../../design-system";
import { formatBytes } from "../helpers";

export function FileDropInput({ file, inputRef, onFileChange }) {
  // Nota: el <Field> padre renderiza un <label>, así que cualquier click
  // dentro de él dispara el <input type="file"> automáticamente. NO añadir
  // onClick manual aquí: provocaría que se abra el picker dos veces.
  return (
    <div
      style={{
        border: "1px dashed var(--kr-border)",
        borderRadius: 8,
        padding: 14,
        background: "var(--kr-bg-subtle)",
        display: "flex",
        alignItems: "center",
        gap: 12,
        cursor: "pointer",
      }}
    >
      <Icon name="Upload" size={20} style={{ color: "var(--kr-fg-muted)", flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        {file ? (
          <>
            <div style={{ fontSize: 13, color: "var(--kr-fg-strong)", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {file.name}
            </div>
            <div style={{ fontSize: 11, color: "var(--kr-fg-muted)", marginTop: 2 }}>
              {formatBytes(file.size)} · Click para cambiar
            </div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 13, color: "var(--kr-fg-strong)", fontWeight: 500 }}>
              Selecciona un archivo
            </div>
            <div style={{ fontSize: 11, color: "var(--kr-fg-muted)", marginTop: 2 }}>
              PDF, imagen u otros formatos hasta 20 MB
            </div>
          </>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        onChange={onFileChange}
        style={{ display: "none" }}
      />
    </div>
  );
}
